var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStsMains(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "electricity-tower-1",
    clipPath: "url(#clip0_206_2774)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.511719 24.1357H24.1348",
    stroke: "white",
    strokeWidth: 1.41263,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.11719 24.1358L9.24185 0.512695H17.4586L18.5832 24.1358",
    stroke: "white",
    strokeWidth: 1.41263,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.3781 0.512695L8.87891 8.13577",
    stroke: "white",
    strokeWidth: 1.41263,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.3541 11.8116L8.875 8.29688",
    stroke: "white",
    strokeWidth: 1.41263,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.32422 0.512695L17.8234 8.13577",
    stroke: "white",
    strokeWidth: 1.41263,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M13.3555 11.8116L17.8346 8.29688",
    stroke: "white",
    strokeWidth: 1.41263,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M23.6026 17.176C23.654 17.2534 23.6836 17.3432 23.688 17.436C23.6924 17.5288 23.6716 17.621 23.6278 17.7029C23.5839 17.7848 23.5187 17.8533 23.439 17.901C23.3593 17.9488 23.2682 17.974 23.1753 17.9741H3.525C3.43211 17.974 3.34097 17.9488 3.26129 17.901C3.18161 17.8533 3.11637 17.7848 3.07252 17.7029C3.02868 17.621 3.00787 17.5288 3.01231 17.436C3.01674 17.3432 3.04627 17.2534 3.09773 17.176L6.52205 12.0406C6.5689 11.9702 6.63242 11.9124 6.70696 11.8725C6.7815 11.8325 6.86475 11.8116 6.94932 11.8115H19.751C19.8356 11.8116 19.9188 11.8325 19.9933 11.8725C20.0679 11.9124 20.1314 11.9702 20.1783 12.0406L23.6026 17.176Z",
    stroke: "white",
    strokeWidth: 1.41263,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M8.73047 11.8115L18.4868 17.9741L21.8762 14.5847",
    stroke: "white",
    strokeWidth: 1.41263,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M17.9739 11.8115L8.21855 17.973L4.82812 14.5826",
    stroke: "white",
    strokeWidth: 1.41263,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M6.16406 0.512695H9.24534",
    stroke: "white",
    strokeWidth: 1.41263,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M17.4609 0.512695H20.5422",
    stroke: "white",
    strokeWidth: 1.41263,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M6.16406 5.64746H9.00089",
    stroke: "white",
    strokeWidth: 1.41263,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M17.707 5.64746H20.5439",
    stroke: "white",
    strokeWidth: 1.41263,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_206_2774"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.6502,
    height: 24.6502,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStsMains);
export default __webpack_public_path__ + "static/media/sts_mains.a5349cde6ba6206825db0bbe45923c96.svg";
export { ForwardRef as ReactComponent };